const isValueInArray = (value, arr) =>
  Array.isArray(arr) ? (arr || []).some((element) => element === value) : false;
const areAllTrue = (arr) =>
  Array.isArray(arr) ? !arr.some((element) => !!element === false) : false;
const removeDuplicates = (arr) => [...new Set([...arr])];

const joinElementsWithSeparatorAndEndingSeparator = (
  array,
  separator,
  endingSeparator
) => {
  const arrayLength = array.length;
  let base = '';

  if (arrayLength > 1) {
    base = array.slice(0, arrayLength - 1).join(separator);
    base = `${base} ${endingSeparator} ${array[arrayLength - 1]}`;
  } else {
    base = array.join(separator);
  }

  return base;
};

export {
  isValueInArray,
  areAllTrue,
  removeDuplicates,
  joinElementsWithSeparatorAndEndingSeparator,
};
export default undefined;
